export const workHistory = [
  {
    from: "June 2024 ",
    to: " Current",
    role: "Software Developer",
    company: "Deloitte",
    descriptions: [
      "Developed advanced form logic and conditional branching, allowing dynamic question flow based on user responses.",
      "Managed real-time response tracking and leaderboard generation, enhancing participant engagement.",
      "Engineered a custom routing feature, boosting revenue by 20%.",
      "Handled deployment and testing of the competition platform, ensuring a smooth launch and scalability.",
    ],

    skills: `ReactJS, TypeScript, Python, NodeJS, PostgreSQL`,
  },
  {
    from: "November 2022 ",
    to: " January 2023",
    role: "FrontEnd Developer",
    company: "Desportivos",
    descriptions: [
      "Prepared the front end using ReactJS and JavaScript.",
      "Enchanced the responsiveness using media queries.",
      "More than 80 Colleges visited the website and registered for the fest.",
    ],

    skills: `HTML, CSS, Javascript, Responsive Design`,
  },
  {
    from: "August 2022 ",
    to: " November 2022",
    role: "React Developer",
    company: "Ajani Infotech Pvt Ltd",
    descriptions: [
      "Leveraged React-Redux bindings for efficient state management.",
      "Employed middleware to handle asynchronous operations and side effects.",
      "Used media queries to improve user experience on different devices, leading to a significant 30% boost in website visits.",
    ],

    skills: `React, Javascript, Responsive Design`,
  },
];
